module.exports = __webpack_public_path__ + "static/media/ssn.a15eae13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ssn.png
// module id = 956
// module chunks = 0